// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"960d7b5d","76":"25ea0590","210":"b0d305dc","243":"03df9823","343":"743b4990","364":"a66f977b","433":"3a9225d4","435":"b1eddaf0","484":"68ee8041","487":"0b816247","488":"801ed0f1","529":"cb57d7e0","540":"5f47688b","591":"c41d9331","683":"43680012","912":"aaa01a18"}[chunkId] + ".chunk.js";
};